import React, { useState, useEffect } from "react";
import FetchData, { CreateEntry, UpdateEntry, GetListAsync } from '../../../providers/dataProvider';
import { CheckNull, FormatValueDecimal, QatarConvertion, calculateNetPrice } from "../../../utils/Validate";
import SaveSuccessModel from "../../../components/common/SaveSuccessModel";
import urls from "../../../constants";
import SelectedConfiguration from "./SelectedConfiguration";
import ProductQuantityTable from "./ProductQuantityTable";
import fallbackImg from "../../../assets/images/product1.png";
import UnSaveModel from "../../common/UnSaveModel";

const OrderQuantityEntry = ({ setOrderProductTab, values, setValues, orderProductTab, currencyDetail }) => {
    // All state management here
    const [productSubmit, setProductSubmit] = useState(false)
    const [productVariant, setProductVariant] = useState([]);
    const [attributeDetails, setattributeDetails] = useState([]);
    const [variantsArray, setvariantsarray] = useState([])
    const [markCreateMessage, setMarkCreateMessage] = useState(null);
    const [createMsg, setCreateMsg] = useState(null)
    const [successshow, setSuccessShow] = useState(false)
    const [addProduct, setAddProduct] = useState([])
    const [productConfigVariant, setProductConfigVariant] = useState([]);
    const [markDetails, setMarkDetails] = useState(null);
    const [orderMarkDetails, setOrderMarkDetails] = useState(null);
    const [configSpecs, setConfigSpecs] = useState([]);
    const [activeTab, setActiveTab] = useState("nav-sizes");
    const [markErrorShow, setMarkErrorShow] = useState({ show: false, errorMessage: "" });
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [showUnsavedModal, setShowUnsavedModal] = useState(false);

    const { data: productVariants, loading: productVariantsLoading, error: productVariantsError } =
        FetchData("productsvariants", { id: markDetails?.groupId || orderProductTab?.data?.groupId });

    const { data: productsconfig, loading: productConfigLoading, error: productConfigError } =
        FetchData("productsspecification", { id: orderProductTab?.data?.productId });


    const isExistingMark = Boolean(orderMarkDetails?.id);

    const initialAddProductSnapshotRef = React.useRef(null);
    const hasCapturedSnapshotRef = React.useRef(false);

    const markDirtyState = (nextProducts) => {
        if (!hasCapturedSnapshotRef.current || !nextProducts) return;
        setHasUnsavedChanges(JSON.stringify(nextProducts) !== initialAddProductSnapshotRef.current);
    };

    const safeNumber = (value, fallback = 0) => {
        const num = Number(value);
        return Number.isFinite(num) ? num : fallback;
    };

    useEffect(() => {

        if (productVariants?.length > 0) {
            const checkGroupVariant = productVariants?.filter(
                (item) => item?.productSubGroupId === orderProductTab?.data?.productSubGroupId && item?.isActive === true
            )
            const resolved = checkGroupVariant?.length > 0
                ? checkGroupVariant
                : productVariants?.filter((item) => item?.isActive === true && (item?.productSubGroupId === 0 || item?.productSubGroupId === null));

            setProductVariant(resolved);
            setProductConfigVariant(resolved);
        }
    }, [productVariants, orderProductTab])

    useEffect(() => {
        const GetMarkDetails = async () => {
            const markData = await GetListAsync("productmark", { id: orderProductTab?.data?.quoteProductId })
            setMarkDetails(markData?.data?.[0]);
            const productFilter = values?.products?.find((item) => item?.quoteProductId === orderProductTab?.data?.quoteProductId)
            let orderMarkDetailsData = null;
            if (productFilter?.id) {
                const ordermarkData = await GetListAsync("orderproductmark", { id: productFilter?.id })
                orderMarkDetailsData = ordermarkData?.data?.[0];
            }

            setOrderMarkDetails(orderMarkDetailsData)

            const productFilterObj = productsconfig?.filter((config) => config?.productId === orderProductTab?.data?.productId)
            let arrayAttribute = [];
            const specificationsToUse = orderMarkDetailsData?.productSpecifications || markData?.data?.[0]?.productSpecifications;
            specificationsToUse?.map((spec) => {
                const findAttribute = productFilterObj?.map((productItem) => productItem?.productSpecMaps)?.flat().filter(specItem => specItem?.attributeId === spec?.specificationId)
                const findvalue = findAttribute?.[0]?.productSpecValueMaps?.filter(valuemap => valuemap?.id === spec?.specificationValueId)

                arrayAttribute.push({
                    ...spec,
                    attributeName: findAttribute?.[0]?.attributeName,
                    attributeValue: findvalue?.[0]?.valueName,
                    groupName: findAttribute?.[0]?.groupName || "MODEL CONFIG",
                })
            })
            setattributeDetails(arrayAttribute)
        }
        if (productsconfig) {
            GetMarkDetails();
        }
    }, [productsconfig])

    useEffect(() => {
        if (attributeDetails?.length > 0) {
            setConfigSpecs(attributeDetails);
        }
    }, [attributeDetails])
    useEffect(() => {
        if (markDetails && productVariant.length > 0) {
            let addProductArray = [];
            let productVariantsArray = [];

            const quoteItems = markDetails?.productItems || [];
            const savedItems = orderMarkDetails?.productItems || [];

            const productItemsToUse = quoteItems.length > 0
                ? quoteItems.map((quoteItem) => {
                    const savedMatch = savedItems.find(
                        (saved) => saved?.quoteProductItemId === quoteItem?.id
                    );
                    return savedMatch
                        ? { ...savedMatch, __isSaved: true, __quoteItem: quoteItem }
                        : { ...quoteItem, __isSaved: false };
                })
                : savedItems;

            if (productItemsToUse?.length > 0) {
                productItemsToUse?.map((prodItem, prodIndex) => {
                    if (!prodItem.__isSaved) {
                        const qtyvariant = prodItem?.productItemVariants?.find(item => urls?.QUANTITY_CONSTANT?.includes(item?.variantId));

                        const quoteQtyForThisItem = Number(qtyvariant?.variantValue ?? prodItem?.quantity ?? 0);
                        const releasedQtyForThisItem = Number(prodItem?.customerOrderedQuantity ?? prodItem?.orderedQuantity ?? 0);
                        const computedRemainingQty = prodItem?.remainingQuantity ?? Math.max(quoteQtyForThisItem - releasedQtyForThisItem, 0);
                        const defaultLpoQty = isExistingMark ? 0 : computedRemainingQty;

                        addProductArray.push({
                            sid: prodIndex + 1,
                            id: 0,
                            quoteProductId: prodItem?.id,
                            isInCurrentOrder: false,
                            notes: prodItem?.notes ?? "",
                            specialDesignRequest: prodItem?.specialDesignRequest ?? "",
                            sdrCharges: prodItem?.sdrCharges ?? 0,
                            qtyValues: quoteQtyForThisItem,
                            listPriceValues: prodItem?.listPrice ?? 0,
                            unitPrice: prodItem?.unitPrice ?? 0,
                            totalPrice: (Number(prodItem?.unitPrice) || 0) * (Number(defaultLpoQty) || 0),
                            releasedQuantity: releasedQtyForThisItem,
                            lpoQuantity: defaultLpoQty,
                            availableForCurrentOrderQuantity: computedRemainingQty,
                            balanceQuantity: prodItem?.balanceQuantity ?? computedRemainingQty,
                            margin: prodItem?.margin ?? 0,
                        });
                        prodItem?.productItemVariants?.map((varItem, varIndex) => {
                            const filterVar = productVariant?.filter(
                                (pvar) => pvar.variantId === varItem.variantId &&
                                    !urls?.HIDDEN_FIELDS_GROUP?.includes(pvar?.groupId)
                            );
                            if (filterVar && filterVar?.length > 0) {
                                productVariantsArray.push({
                                    sid: (prodIndex * 1) + 1,
                                    id: varItem.id,
                                    quoteProductItemId: prodItem.id,
                                    orderProductItemId: 0,
                                    variantId: varItem?.variantId,
                                    variantValue: varItem?.variantValue,
                                    inputByUser: filterVar[0].inputByUser,
                                });
                            }
                        });
                    } else {
                        const qtyForThisItem = safeNumber(prodItem?.quoteQuantity ?? orderMarkDetails?.quotedQuantity, 0);
                        const releasedForThisItem = safeNumber(prodItem?.releasedQuantity ?? orderMarkDetails?.releasedQuantity, 0);
                        const savedLpoQuantity = prodItem?.currentOrderQuantity ?? prodItem?.lpoQuantity ?? 0;

                        addProductArray.push({
                            sid: (prodIndex * 1) + 1,
                            id: prodItem?.id,
                            quoteProductId: prodItem?.quoteProductItemId,
                            orderProductId: prodItem?.orderProductId,
                            notes: prodItem?.notes,
                            specialDesignRequest: prodItem?.specialDesignRequest,
                            sdrCharges: prodItem?.sdrCharges,
                            qtyValues: prodItem?.quoteQuantity ?? qtyForThisItem,
                            listPriceValues: prodItem?.listPrice,
                            unitPrice: prodItem?.unitPrice,
                            totalPrice: (Number(prodItem?.unitPrice) || 0) * (Number(savedLpoQuantity) || 0),
                            releasedQuantity: prodItem?.customerOrderedQuantity ?? releasedForThisItem,
                            lpoQuantity: savedLpoQuantity,
                            availableForCurrentOrderQuantity: prodItem?.availableForCurrentOrderQuantity ?? Math.max(qtyForThisItem - releasedForThisItem, 0),
                            balanceQuantity: prodItem?.balanceQuantity ?? 0,
                            isInCurrentOrder: prodItem?.isInCurrentOrder ?? true,
                            multiplier: prodItem?.multiplier,
                            margin: prodItem?.margin ?? 0,
                        });

                        const variantsSource = prodItem?.productItemVariants?.length > 0
                            ? prodItem?.productItemVariants
                            : prodItem?.__quoteItem?.productItemVariants;

                        variantsSource?.map((varItem, varIndex) => {
                            const filterVar = productVariant?.filter(
                                (pvar) => pvar.variantId === varItem.variantId &&
                                    !urls?.HIDDEN_FIELDS_GROUP?.includes(pvar?.groupId)
                            );
                            if (filterVar && filterVar?.length > 0) {
                                productVariantsArray.push({
                                    sid: (prodIndex * 1) + 1,
                                    id: varItem.id,
                                    quoteProductItemId: prodItem?.quoteProductItemId,
                                    orderProductItemId: varItem.orderProductItemId ?? prodItem?.id,
                                    variantId: varItem?.variantId,
                                    variantValue: varItem?.variantValue,
                                    inputByUser: filterVar[0].inputByUser,
                                });
                            }
                        });
                    }
                });

                if (productVariantsArray?.length > 0) {
                    setvariantsarray(productVariantsArray);
                }
                setAddProduct(addProductArray);
            }
        }
    }, [markDetails, productVariant, orderMarkDetails])

    useEffect(() => {
        if (!hasCapturedSnapshotRef.current && addProduct?.length > 0) {
            initialAddProductSnapshotRef.current = JSON.stringify(addProduct);
            hasCapturedSnapshotRef.current = true;
            setHasUnsavedChanges(false);
        }
    }, [addProduct]);


    useEffect(() => {
        if (productSubmit === true) {
            const createValue = {
                ...values,
                CreatedAt: new Date(),
                CreatedBy: localStorage.getItem("authidentity")
            };
            CreateEntry("order", createValue, setCreateMsg, "success", "Failed to create order");
        }
    }, [productSubmit])


    useEffect(() => {
        if (createMsg) {
            if (CheckNull(createMsg?.message) == "success") {
                if (typeof setValues === "function" && createMsg?.successData?.id) {
                    setValues((prev) => ({
                        ...prev,
                        ...createMsg.successData,
                        id: createMsg.successData.id,
                    }));
                }
                CreateProductOrder();
            } else {
                console.error("Order create failed:", createMsg);
            }
            setProductSubmit(false);
        }
    }, [createMsg])

    useEffect(() => {
        if (!markCreateMessage) return;

        const statusCode = markCreateMessage?.statusCode ?? markCreateMessage?.status;
        const isSuccess = statusCode === 200 || statusCode === 201 || statusCode === 204;

        if (isSuccess) {
            setSuccessShow(true);
            const rawUpdatedMark = markCreateMessage?.successData;
            if (rawUpdatedMark?.id && typeof setValues === "function") {
                const totalReleasedQuantity = addProduct.reduce((sum, p) => sum + (Number(p?.releasedQuantity) || 0), 0);
                const totalLpoQuantity = addProduct.reduce((sum, p) => sum + (Number(p?.lpoQuantity) || 0), 0);

                const totalListPrice = addProduct.reduce(
                    (sum, p) => sum + ((Number(p?.listPriceValues) || 0) * (Number(p?.lpoQuantity) || 0)),
                    0
                );

                const totalSellingPrice = calculateNetPrice({
                    productItems: addProduct.map((p) => ({
                        unitPrice: p?.unitPrice,
                        quantity: p?.lpoQuantity,
                    })),
                    listPrice: totalListPrice,
                    margin: orderMarkDetails?.margin ?? markDetails?.margin,
                });

                const aggregateFields = {
                    releasedQuantity: totalReleasedQuantity,
                    orderQuantity: totalLpoQuantity,
                    listPrice: totalListPrice,
                    sellingPrice: totalSellingPrice,
                };



                const productItemsWithVariants = (rawUpdatedMark?.productItems || []).map((pi) => {
                    if (pi?.productItemVariants?.length > 0) return pi;

                    const submittedVariants = variantsArray
                        ?.filter((v) =>
                            v?.quoteProductItemId === pi?.quoteProductItemId ||
                            v?.quoteProductItemId === pi?.id
                        )
                        ?.map((v) => ({
                            id: v?.id ?? 0,
                            orderProductItemId: pi?.id,
                            variantId: v?.variantId,
                            variantValue: v?.variantValue,
                        })) || [];

                    return submittedVariants.length > 0
                        ? { ...pi, productItemVariants: submittedVariants }
                        : pi;
                });

                const updatedMark = { ...rawUpdatedMark, productItems: productItemsWithVariants };

                setValues((prev) => {
                    const products = prev?.products || [];
                    const exists = products.some((p) => p?.id === updatedMark.id);
                    const mergeMark = (oldItem, newItem) => {
                        const merged = { ...oldItem };
                        Object.keys(newItem || {}).forEach((key) => {
                            const value = newItem[key];
                            if (value !== null && value !== undefined && value !== "") {
                                merged[key] = value;
                            }
                        });
                        return merged;
                    };

                    let updatedProducts;
                    if (exists) {
                        updatedProducts = products.map((p) =>
                            p?.id === updatedMark.id
                                ? { ...mergeMark(p, updatedMark), ...aggregateFields }
                                : p
                        );
                    } else {
                        updatedProducts = [
                            ...products,
                            {
                                ...updatedMark,
                                productName: updatedMark?.productName || orderProductTab?.data?.productName,
                                ...aggregateFields,
                            },
                        ];
                    }
                    return { ...prev, products: updatedProducts };
                });
                setHasUnsavedChanges(false);
            }
        } else {
            const apiErrors = markCreateMessage?.errors?.length > 0
                ? markCreateMessage.errors
                : markCreateMessage?.successData?.errors;

            const simpleText = apiErrors?.length > 0
                ? apiErrors.map(e => e.message || e.code).join(" ")
                : (CheckNull(markCreateMessage?.statusPhrase) || CheckNull(markCreateMessage?.message) || "Something went wrong. Please try again.");

            console.error("Order product mark save failed:", markCreateMessage);
            setSuccessShow(false);
            setMarkErrorShow({ show: true, errorMessage: simpleText });
        }
    }, [markCreateMessage])

    const CreateProductOrder = () => {
        let submitdata = [];

        const validProducts = addProduct.filter((productitem) => {
            const qty = Number(productitem?.lpoQuantity);
            if (!Number.isFinite(qty) || qty < 0) return false;

            // Backend rejects the WHOLE request if a brand-new item (id 0) is sent
            // with 0 quantity — so untouched rows must be excluded from payload.
            // Existing/saved items (id > 0) can always be sent, even reduced to 0.
            const alreadyInOrder = (productitem?.id ?? 0) > 0;
            if (!alreadyInOrder && qty === 0) return false;

            return true;
        });

        if (validProducts.length === 0) {
            setMarkErrorShow({
                show: true,
                errorMessage: "Each order item must reference a quote item and have a quantity greater than zero."
            });
            return;
        }

        validProducts.map((productitem, productindex) => {
            let list = variantsArray.filter(function (data) {
                return data.sid === productitem?.sid
            })
            const variantslist = list?.map((element, index) => {
                let variantsdata = {
                    id: element?.id ?? 0,
                    orderProductItemId: element?.orderProductItemId ?? 0,
                    variantId: element?.variantId,
                    variantValue: element?.variantValue
                }
                return variantsdata;
            });
            let params = {
                id: productitem?.id > 0 ? productitem?.id : 0,
                quoteProductItemId: list?.[0]?.quoteProductItemId ?? productitem?.quoteProductId,
                orderProductId: productitem?.orderProductId,
                listPrice: productitem?.listPriceValues,
                lpoQuantity: safeNumber(productitem?.lpoQuantity, 0),
                unitPrice: safeNumber(
                    FormatValueDecimal(QatarConvertion(productitem?.unitPrice, currencyDetail?.conversionRate, currencyDetail?.shortCode))
                ),
                margin: productitem?.margin,
                totalPrice: safeNumber(
                    FormatValueDecimal(QatarConvertion(productitem?.totalPrice, currencyDetail?.conversionRate, currencyDetail?.shortCode))
                ),
                notes: productitem?.notes,
                specialDesignRequest: productitem?.specialDesignRequest,
                sdrCharges: safeNumber(
                    FormatValueDecimal(QatarConvertion(productitem?.sdrCharges, currencyDetail?.conversionRate, currencyDetail?.shortCode))
                ),
                productItemVariants: variantslist,
            }
            submitdata.push(params)
        })

        const specificationsToSubmit = configSpecs?.length > 0
            ? configSpecs.map((spec) => ({
                orderProductId: spec?.orderProductId,
                specificationId: spec?.specificationId,
                specificationValueId: spec?.specificationValueId,
                specialValue: spec?.specialValue || "",
                specialCharges: spec?.specialCharges || 0,
            }))
            : (orderMarkDetails?.productSpecifications || markDetails?.productSpecifications);

        if (submitdata?.length === 0) {
            console.error("CreateProductOrder aborted: submitdata is empty — addProduct may not be loaded yet.");
            return;
        }

        const totalLpoQuantity = submitdata.reduce((sum, item) => sum + (Number(item.lpoQuantity) || 0), 0);

        const commonMarkData = {
            orderId: CheckNull(values?.id) !== "" ? values?.id : createMsg?.successData?.id,
            quoteProductId: markDetails?.id,
            markName: orderMarkDetails?.markName ?? markDetails?.markName,
            productId: orderMarkDetails?.productId ?? markDetails?.productId,
            groupId: orderMarkDetails?.groupId ?? markDetails?.groupId,
            groupName: orderMarkDetails?.groupName ?? markDetails?.groupName,
            productSubGroupId: orderMarkDetails?.productSubGroupId ?? markDetails?.productSubGroupId,
            quantity: markDetails?.quantity ?? 0,
            listPrice: markDetails?.listPrice,
            margin: markDetails?.margin ?? 0,
            salesMargin: markDetails?.margin ?? 0,
            sellingPrice: markDetails?.sellingPrice,
            lpoQuantity: totalLpoQuantity,
            productItems: submitdata,
            productSpecifications: specificationsToSubmit
        };

        if (isExistingMark) {
            const editMarkData = {
                ...commonMarkData,
                id: orderMarkDetails?.id,
            };
            UpdateEntry("updateorderproductmark", editMarkData, setMarkCreateMessage, "Product updated successfully", "Failed to update product")
        } else {
            CreateEntry("orderproductmark", commonMarkData, setMarkCreateMessage, "Product submitted successfully", "Failed to submit product")
        }
    }

    const handleSave = () => {
        if (CheckNull(values?.id) !== "") {
            CreateProductOrder();
        } else {
            setProductSubmit(true);
        }
    };

    const SuccessDoneClick = () => {
        setSuccessShow(false);
        setMarkCreateMessage(null);
        setOrderProductTab({ tab: "ProductList", id: 0, status: "updated" });
    };
    const goBack = () => {
        if (hasUnsavedChanges) {
            setShowUnsavedModal(true);
            return;
        }
        setOrderProductTab({ tab: "" });
    };

    const handleUnsavedCancel = () => {
        setShowUnsavedModal(false);
        setHasUnsavedChanges(false);
        setOrderProductTab({ tab: "" });
    };

    const handleUnsavedSave = () => {
        setShowUnsavedModal(false);
        handleSave();
    };

    const handleImgError = (e) => {
        e.target.onerror = null;
        e.target.src = fallbackImg;
    };

    const groupedSpecs = configSpecs.reduce((acc, spec) => {
        const group = spec?.groupName || "MODEL CONFIG";
        if (!acc[group]) acc[group] = [];
        acc[group].push(spec);
        return acc;
    }, {});

    return (
        <div className="order-configuration">
            <div className="card">
                <div className="card-body">
                    <div className="order-tab-header-card d-flex align-items-center justify-content-between mb-0">
                        <div className="d-flex align-items-center">
                            <button className="angle-left">
                                <i className="fas fa-angle-left" title="Back" onClick={goBack} style={{ cursor: "pointer" }}></i>
                            </button>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <button
                                        className={`nav-link${activeTab === "nav-configuration" ? " active" : ""}`}
                                        id="nav-configuration-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="nav-configuration"
                                        aria-selected={activeTab === "nav-configuration"}
                                        onClick={() => setActiveTab("nav-configuration")}
                                    >
                                        Configuration
                                    </button>
                                    <button
                                        className={`nav-link${activeTab === "nav-sizes" ? " active" : ""}`}
                                        id="nav-sizes-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="nav-sizes"
                                        aria-selected={activeTab === "nav-sizes"}
                                        onClick={() => setActiveTab("nav-sizes")}
                                    >
                                        Sizes
                                    </button>
                                </div>
                            </nav>
                        </div>
                        <button
                            type="button"
                            className="btn update-btn"
                            onClick={handleSave}
                        >
                            <i className="fas fa-save mr-1"></i>
                            {isExistingMark ? "Update" : "Save"}
                        </button>
                    </div>
                </div>
            </div>

            <div className="tab-content" id="nav-tabContent">

                <div className={`tab-pane fade${activeTab === "nav-sizes" ? " show active" : ""}`} id="nav-sizes" role="tabpanel" aria-labelledby="nav-sizes-tab">
                    <ProductQuantityTable
                        orderMarkDetails={orderMarkDetails}
                        currencyDetail={currencyDetail}
                        addProduct={addProduct}
                        variantsArray={variantsArray}
                        productConfigVariant={productConfigVariant}
                        setAddProduct={setAddProduct}
                        markDirtyState={markDirtyState}
                        markErrorShow={markErrorShow}
                        setMarkErrorShow={setMarkErrorShow}
                    />
                </div>

                <div className={`tab-pane fade${activeTab === "nav-configuration" ? " show active" : ""}`} id="nav-configuration" role="tabpanel" aria-labelledby="nav-configuration-tab">
                    <div className="row">
                        <div className="col-xxl-9 col-xl-9 col-lg-8 col-md-12 configuration-col mt-2">
                            <div className="card">
                                <div className="card-body">
                                    <div>
                                        <h5>MODEL CONFIGURATION</h5>
                                        <span>{configSpecs?.length || 0} configured</span>
                                    </div>
                                </div>
                                <table>
                                    {Object.entries(groupedSpecs).map(([groupName, specs]) => (
                                        <React.Fragment key={groupName}>
                                            <thead>
                                                <tr>
                                                    <th colSpan="3">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <h2>{groupName}</h2>
                                                            <p>{specs.length} field{specs.length !== 1 ? "s" : ""}</p>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {specs.map((spec, index) => (
                                                    <tr key={spec?.id || spec?.specificationId}>
                                                        <td className="slno">{index + 1}</td>
                                                        <td className="label">{spec?.attributeName}</td>
                                                        <td>
                                                            <span className="config-value-text">
                                                                {spec?.attributeValue === "Custom Colour"
                                                                    ? spec?.specialValue
                                                                    : (spec?.attributeValue || spec?.specialValue || "-")}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </React.Fragment>
                                    ))}
                                </table>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-12 selected-model-col mt-2">
                            <div className="card mb-1">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <h2>Selected Model : <span>{orderProductTab?.data?.productName}</span></h2>
                                            <div className="d-flex align-items-center justify-content-between mb-1 gap">
                                                <img
                                                    src={orderProductTab?.data?.productImage || fallbackImg}
                                                    onError={handleImgError}
                                                    alt={orderProductTab?.data?.productName}
                                                />
                                                <div className="product-details">
                                                    {configSpecs?.map((spec) => (
                                                        <span key={spec?.id || spec?.specificationId}>
                                                            {spec?.attributeName}: <strong>{spec?.attributeValue || spec?.specialValue || "-"}</strong> ›
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion" id="accordionExample">
                                <div className="card mb-1">
                                    <div className="card-header" id="headingOne">
                                        <h2 className="mb-0">
                                            <button className="btn btn-link" type="button"
                                                data-toggle="collapse"
                                                data-target="#collapseOne"
                                                aria-expanded="true"
                                                aria-controls="collapseOne">
                                                Product Data
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapseOne"
                                        className="collapse show"
                                        aria-labelledby="headingOne"
                                        data-parent="#accordionExample">
                                        <div className="card-body">
                                            No product data available
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Same "Selected Configuration" detail block used on the Quotation page */}
                            <SelectedConfiguration
                                currencyDetail={currencyDetail}
                                orderProductTab={orderProductTab}
                                attributeDetails={configSpecs}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <SaveSuccessModel
                show={successshow}
                createMsg={markCreateMessage}
                setShow={setSuccessShow}
                SuccessDoneClick={SuccessDoneClick}
            />
            <UnSaveModel
                show={showUnsavedModal}
                setShow={setShowUnsavedModal}
                title="Unsaved Changes"
                buttonText="Save"
                SuccessDoneClick={handleUnsavedCancel}
                SaveProductMarkAdd={handleUnsavedSave}
            />
        </div>
    );
};

export default OrderQuantityEntry
